import React, { useState, useEffect,useRef } from 'react';
import { Button, Link, FormControl, FormControlLabel, InputLabel, MenuItem, Select, Tooltip, TextField } from '@mui/material'
import Dialog from '@mui/material/Dialog';
import ImageComponents from '../../../../Shared/ImageComponents'
import UpiPaymentDialog from '../../../../Shared/UpipaymentDialog';
import PaymentSteps from '../../../PaymentSteps/PaymentSteps';
import UpiQR from './UpiQR';
import CustomizedDialogs from "../../../../Shared/CustomDialogs";
import UpiPaymentProcess from './UpiPaymentProcess';
import PaymentFailedPopup from './upiRetry';
import fetchTxnStatus from '../../Components/fetchTxnStatus';
import Loader from '../../Components/loader';
import getDomain from '../../Components/getDomain';
import { openExternalLink, onNativeExternalLinkResult } from '../../../../Utility/deviceUtils';
import IntentPaymentStatusDialog from './IntentPaymentStatusDialog';


function UpiDetails({payModesToPass}) {
   console.log('upi'+payModesToPass);
  const IOS_UPI_APPS = [
    { name: 'PhonePe', appPackage: 2 },
    { name: 'Google Pay', appPackage: 3 },
    { name: 'BHIM', appPackage: 4 },
    { name: 'Paytm', appPackage: 1 },
  ];
  const [selectOtherApps, setSelectOtherApps] = React.useState('');
  const [showUpiBarCode, setShowUpiBarCode] = useState(false);
  const [showUpiPopUp, setshowUpiPopUp] = useState(false);
  const [payId, setPayId] = useState('');
  const [QrCodeData , setQrCodeData] = useState('');
  const [responseData, setResponseData] = useState('');
  const [validVPAerror, setvalidVPAerror] = useState('');
  const [showUpiIntent, setshowUpiIntent] = useState(false);
  const [showUpiQR, setshowUpiQR] = useState(false);
  const [showLoader, setshowLoader] = useState(false);
  const [showRetry, setShowRetry] = useState(false);
  const [showCheck, setShowCheck] = useState(false);
  const [txAmount , settxAmount ]= useState('');
  const [statusWaitTime , setWaitStatusTime] = useState('5');
  const [mode, setMode] = useState('');
  const isCheckingStatusRef = useRef(false);
  const [isDisplayModeFive, setIsDisplayModeFive] = useState(false);
  const [isMotorProduct, setIsMotorProduct] = useState(false);
  const [isAppSwitched, setIsAppSwitched] = useState(false);
  const [isIosDevice, setIsIosDevice] = useState(false);
  const [isEligibleForIosPSPIntent, setIsEligibleForIosPSPIntent] = useState(false);
  const lastVisibilityStateRef = useRef(document.visibilityState);
  const isPollingRef = useRef(false);
  const [isEligibleForUpiCollect, setIsEligibleForUpiCollect] = useState(false);
  const [showAppNotInstalled, setShowAppNotInstalled] = useState(false);
  const [notInstalledAppName, setNotInstalledAppName] = useState('');
  const [showIntentStatusDialog, setShowIntentStatusDialog] = useState(false);
  const intentStatusDetailsRef = useRef(null);
  const intentPollingSessionRef = useRef(0);
  const appNotInstalledTimerRef = useRef(null);
  const appOpenWatchCleanupRef = useRef(null);
   let var1;
   let var2;
  const divStyle = {
  alignSelf: 'flex-end',
  paddingBottom: '3%',
  textAlign: 'justify',
  boxSizing: 'border-box',
  fontFamily: 'Roboto, "Segoe UI", -apple-system, "Helvetica Neue", BlinkMacSystemFont, Oxygen-Sans, Ubuntu, Cantarell, sans-serif',
  fontSize: '0.8em' 
};


 
   
  useEffect(() => {
    const userAgent = window.navigator.userAgent || '';
    const iOSPattern = /iPad|iPhone|iPod/.test(userAgent);
    const iPadOsPattern =
      window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1;
    setIsIosDevice(iOSPattern || iPadOsPattern);
  }, []);

  useEffect(() => {
    if (payModesToPass) {
      setshowUpiIntent(!!payModesToPass.isEligibleForUpiIntent);
      setIsEligibleForIosPSPIntent(!!payModesToPass.isEligibleForIosPSPIntent);
      setshowUpiQR(payModesToPass.showQrCodePayMode);
      settxAmount(payModesToPass.txAmount);
      setShowCheck(payModesToPass.check);
      setIsEligibleForUpiCollect(payModesToPass.isEligibleForUpiCollect);
      setIsMotorProduct(payModesToPass.isMotorProduct);
       if (payModesToPass.displayMode === 5) {
        setIsDisplayModeFive(true);
        settxAmount(payModesToPass.multipliedAmount);
      	} 
    }
  }, [payModesToPass]);

  const handleChange = (event) => {
    setSelectOtherApps(event.target.value);
  };

  const [vpa, setVpa] = useState('');
  const isVpaPatternValid = (value) => {
    if (!value) return false;
    const trimmed = String(value).trim();
    const atIndex = trimmed.indexOf('@');
    return atIndex > 0 && trimmed.length - atIndex - 1 >= 3;
  };

  const handleVpaChange = (event) => {
    setVpa(event.target.value);
  };

  const handleVpaClick = (event) => {
    setvalidVPAerror('');
  };
	
  const domain = getDomain();
  const actionUrl = domain+`/pay/payment/upi/thankyou`;	
	
  const clearAppOpenWatch = () => {
    if (appNotInstalledTimerRef.current) {
      clearTimeout(appNotInstalledTimerRef.current);
      appNotInstalledTimerRef.current = null;
    }
    appOpenWatchCleanupRef.current?.();
    appOpenWatchCleanupRef.current = null;
  };

  const handleIntentPayNow = async (appPackage = null, appName = null) => {
    clearAppOpenWatch();
    setShowAppNotInstalled(false);
    setNotInstalledAppName('');
    setshowLoader(true);
    const queryParameters = new URLSearchParams(window.location.search);
    const order = queryParameters.get("orderNo");
    var1 = queryParameters.get("var1");
    var2 = queryParameters.get("var2");
    const mode = "UPI_INTENT";
    setMode('UPI_INTENT');
    const payload = {
      orderNo: order,
      mode: mode,
    };
    if (appPackage !== null && appPackage !== undefined) {
      payload.appPackage = appPackage;
    }
    try {
      const response = await fetch('/pay/securePayment/process/intermediate/paymentui', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      const data1 = await response.json();
      console.log(data1.data);
      if(data1 && data1.data.decPayId){
        const decPayId = data1.data.decPayId;
        var1 = data1.data.interStatusVar1;
        var2 = data1.data.interStatusVar2;
        setPayId(decPayId);
        const intentPollingSession = ++intentPollingSessionRef.current;
        intentStatusDetailsRef.current = { payId: decPayId, var1, var2 };
        isCheckingStatusRef.current = true;
        setshowLoader(false);
        setShowIntentStatusDialog(true);
        const openedViaNativeBridge = openExternalLink(data1.data.intentLink);

        if (isIosDevice && appPackage !== null) {
          let appOpenDetected = false;

          const markAppOpened = () => {
            appOpenDetected = true;
          };

          const showAppNotInstalledDialog = () => {
            if (appOpenDetected) return;
            ++intentPollingSessionRef.current;
            isCheckingStatusRef.current = false;
            setshowLoader(false);
            setShowIntentStatusDialog(false);
            setNotInstalledAppName(appName || 'this app');
            setShowAppNotInstalled(true);
          };

          const onHidden = () => {
            if (document.visibilityState === 'hidden') markAppOpened();
          };
          const onBlur = () => markAppOpened();

          document.addEventListener('visibilitychange', onHidden);
          window.addEventListener('blur', onBlur);

          appOpenWatchCleanupRef.current = () => {
            document.removeEventListener('visibilitychange', onHidden);
            window.removeEventListener('blur', onBlur);
            removeNativeListener?.();
          };

          let removeNativeListener = null;
          if (openedViaNativeBridge) {
            removeNativeListener = onNativeExternalLinkResult(markAppOpened, () => {
              clearAppOpenWatch();
              showAppNotInstalledDialog();
            });
          }

          setTimeout(
            () => checkTransactionStatus(decPayId, var1, var2, intentPollingSession),
            data1.data.upiWaitStatusTime * 1000
          );

          appNotInstalledTimerRef.current = setTimeout(() => {
            clearAppOpenWatch();
            if (!appOpenDetected && document.visibilityState === 'visible') {
              showAppNotInstalledDialog();
            }
          }, 5000);
        } else {
          setTimeout(
            () => checkTransactionStatus(decPayId, var1, var2, intentPollingSession),
            data1.data.upiWaitStatusTime * 1000
          );
        }
      } else {
        setshowLoader(false);
        // handle error
      }
    } catch (error) {
      console.error('Error:', error);
      setshowLoader(false);
    }
  };

  const retryPayment = async () => {
   setShowRetry(false);
   if(mode ==='UPI'){
   handlePayNow();
   }else if(mode === 'UPI-QR'){
   handleQRPayNow();
   }else if(mode === 'UPI_INTENT'){
   handleIntentPayNow();
   }
  };
  
  
    const handleCloseDialog = () => {
    ++intentPollingSessionRef.current;
    isCheckingStatusRef.current = false;
    isPollingRef.current = false;
    setShowIntentStatusDialog(false);
    setShowUpiBarCode(false);
    setshowUpiPopUp(false);
    setShowRetry(false);
  };

  const cancelIntentPayment = async () => {
    const cancellationStartedAt = Date.now();
    const intentStatusDetails = intentStatusDetailsRef.current;
    const keepCancellationFeedbackVisible = async () => {
      const remainingTime = Math.max(0, 2000 - (Date.now() - cancellationStartedAt));
      if (remainingTime) await new Promise(resolve => setTimeout(resolve, remainingTime));
    };

    ++intentPollingSessionRef.current;
    isCheckingStatusRef.current = false;
    isPollingRef.current = false;
    clearAppOpenWatch();

    try {
      if (intentStatusDetails) {
        const response = await fetchTxnStatus(
          encodeURIComponent(intentStatusDetails.payId),
          intentStatusDetails.var1,
          intentStatusDetails.var2
        );
        if (response?.status === 'TXN_SUCCESS') {
          await keepCancellationFeedbackVisible();
          setShowIntentStatusDialog(false);
          submitFormWithPayId(intentStatusDetails.payId, intentStatusDetails.var1, intentStatusDetails.var2);
          return;
        }
      }
    } catch (error) {
      console.log('Final UPI Intent status check failed:', error);
    }

    await keepCancellationFeedbackVisible();
    setshowLoader(false);
    setShowIntentStatusDialog(false);
  };

  const handleCloseAppNotInstalled = () => {
    clearAppOpenWatch();
    setShowAppNotInstalled(false);
  };

  const handleAppNotInstalledExited = () => {
    setNotInstalledAppName('');
  };

  const handleQRPayNow = async () => {
    setshowLoader(true);
    const queryParameters = new URLSearchParams(window.location.search);
    const order = queryParameters.get("orderNo");
    var1 = queryParameters.get("var1");
    var2 = queryParameters.get("var2");
    const mode = "UPI-QR";
    setMode('UPI-QR');
    try {
      const response = await fetch('/pay/securePayment/process/intermediate/paymentui', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          orderNo: order,
          mode: mode,
        })
      });
      const data = await response.json();
      console.log(data);
      if(data && data.decQrPayId){
       
      	setQrCodeData(data);
        setshowLoader(false);
        setShowUpiBarCode(true);
    
        setWaitStatusTime(data.qrCodeWaitStatusTime);
        const decPayId = data.decQrPayId;
        var1 = data.interStatusVar1;
        var2 = data.interStatusVar2;
        setPayId(decPayId);
     	isCheckingStatusRef.current = true; 
        setTimeout(() => checkTransactionStatus(decPayId, var1, var2), data.qrCodeWaitStatusTime * 1000);
        	
      } else {
        setshowLoader(false);
        // handle error
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };




  const handlePayNow = async () => {
    if (vpa !== '' && isVpaPatternValid(vpa)) {
    setshowLoader(true);
    const queryParameters = new URLSearchParams(window.location.search);
    const order = queryParameters.get("orderNo");
    var1 = queryParameters.get("var1");
    var2 = queryParameters.get("var2");
    const decodedVpa = decodeURIComponent(vpa);
    const mode = "UPI";
    setMode('UPI');
    try {
      const response = await fetch('/pay/validate/vpa', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          orderNo: order,
          mode: mode,
          json: decodedVpa,
          var1: var1,
          var2: var2
        })
      });
      const data = await response.json();
      console.log(data);
      console.log('isVPAValid value:', data.data.isVPAValid);

      if (data.data.isVPAValid === 1) {
        const response1 = await fetch('/pay/securePayment/process/intermediate/paymentui', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            orderNo: order,
            mode: mode,
            vpa: decodedVpa
          })
        });
        const data1 = await response1.json();
        setQrCodeData(data1.data);
        console.log(data1);
        const decPayId = data1.data.decPayId;
        var1 = data1.data.interStatusVar1;
        var2 = data1.data.interStatusVar2;

        setPayId(decPayId);
        setshowLoader(false);
        if (data1.data.decPayId) {
          setWaitStatusTime(data1.upiWaitStatusTime);
          setshowUpiPopUp(true);
          isCheckingStatusRef.current = true;
          setTimeout(() => checkTransactionStatus(decPayId, var1, var2), data1.data.upiWaitStatusTime * 1000);
        } else {
          setshowLoader(false);
          setvalidVPAerror('Some error occured, Please try again!');
        }
      } else {
        setshowLoader(false);
        setvalidVPAerror('Please enter a valid VPA');
      }
    } catch (error) {
      console.error('Error:', error);
    }}
    else{
    setvalidVPAerror('Please enter a valid VPA');
    }
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      console.log('App Switch Detection:', {
        previousState: lastVisibilityStateRef.current,
        newState: document.visibilityState,
        isCheckingStatus: isCheckingStatusRef.current,
        isPolling: isPollingRef.current,
        timestamp: new Date().toISOString()
      });

      if (document.visibilityState === 'visible' && 
          lastVisibilityStateRef.current === 'hidden' && 
          isCheckingStatusRef.current) {
        console.log('Detected return from app switch');
        setIsAppSwitched(true);
        if (!showUpiPopUp && !showUpiBarCode && !showIntentStatusDialog) {
          setshowLoader(true);
        }
        console.log('Resuming polling after app switch');
        isCheckingStatusRef.current = true;
        isPollingRef.current = true;
      } else if (document.visibilityState === 'hidden') {
        isPollingRef.current = false;
      }

      lastVisibilityStateRef.current = document.visibilityState;
    };

    const handleFocus = () => {
      console.log('Window Focus:', {
        isCheckingStatus: isCheckingStatusRef.current,
        isPolling: isPollingRef.current,
        isAppSwitched,
        timestamp: new Date().toISOString()
      });

      if (isAppSwitched && isCheckingStatusRef.current) {
        console.log('Resuming after app switch (focus)');
        isCheckingStatusRef.current = true;
        isPollingRef.current = true;
        setIsAppSwitched(false);
      }
    };

    const handleBlur = () => {
      console.log('Window Blur:', {
        isCheckingStatus: isCheckingStatusRef.current,
        isPolling: isPollingRef.current,
        timestamp: new Date().toISOString()
      });
      isPollingRef.current = false;
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
    };
  }, [isAppSwitched, showUpiPopUp, showUpiBarCode, showIntentStatusDialog]);

  const checkTransactionStatus = async (payId, var1, var2, intentPollingSession = null) => {
    if (!isCheckingStatusRef.current || (intentPollingSession !== null && intentPollingSession !== intentPollingSessionRef.current)) {
      return;
    }

    let retries = 0;
    const maxRetries = 60;
    isPollingRef.current = true;

    const handleVisibilityChange = () => {
      console.log('Transaction Status - Visibility Change:', {
        previousState: lastVisibilityStateRef.current,
        newState: document.visibilityState,
        isCheckingStatus: isCheckingStatusRef.current,
        isPolling: isPollingRef.current,
        timestamp: new Date().toISOString()
      });

      if (document.visibilityState === 'visible' && 
          lastVisibilityStateRef.current === 'hidden' && 
          isCheckingStatusRef.current) {
        console.log('Resuming polling after app switch');
        retries = 0;
        setShowRetry(false);
        isCheckingStatusRef.current = true;
        isPollingRef.current = true;
      } else if (document.visibilityState === 'hidden') {
        isPollingRef.current = false;
      }
      
      lastVisibilityStateRef.current = document.visibilityState;
    };

    const handlePageShow = (event) => {
      console.log('Transaction Status - Page Show:', {
        fromCache: event.persisted,
        isCheckingStatus: isCheckingStatusRef.current,
        isPolling: isPollingRef.current,
        timestamp: new Date().toISOString()
      });
      if (isCheckingStatusRef.current) {
        retries = 0;
        setShowRetry(false);
        isCheckingStatusRef.current = true;
        isPollingRef.current = true;
      }
    };

    const handlePageHide = (event) => {
      console.log('Transaction Status - Page Hide:', {
        toCache: event.persisted,
        isCheckingStatus: isCheckingStatusRef.current,
        isPolling: isPollingRef.current,
        timestamp: new Date().toISOString()
      });
      isPollingRef.current = false;
    };

    const cleanup = () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pageshow', handlePageShow);
      window.removeEventListener('pagehide', handlePageHide);
      isPollingRef.current = false;
      isCheckingStatusRef.current = false;
    };

    try {
      let txnStatus = '';
      console.log('Adding transaction status event listeners...');
      
      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('pageshow', handlePageShow);
      window.addEventListener('pagehide', handlePageHide);
      
      console.log('Transaction status event listeners added');
      console.log('Current visibility state:', document.visibilityState);
      console.log('isCheckingStatus:', isCheckingStatusRef.current);
      console.log('isPolling:', isPollingRef.current);

      while (
        isCheckingStatusRef.current &&
        (intentPollingSession === null || intentPollingSession === intentPollingSessionRef.current) &&
        retries < maxRetries
      ) {
        if (!isPollingRef.current) {
          await new Promise(resolve => setTimeout(resolve, 1000));
          continue;
        }
        retries++;
        const encodedPayId = encodeURIComponent(payId);
        const response = await fetchTxnStatus(encodedPayId, var1, var2);
        if (!isCheckingStatusRef.current || (intentPollingSession !== null && intentPollingSession !== intentPollingSessionRef.current)) {
          break;
        }
        if(response === null) {
          continue;
        }
        txnStatus = response.status;
        
        if (txnStatus === 'TXN_SUCCESS') {
          cleanup();
          submitFormWithPayId(payId, var1, var2);
          break;
        }
        else if(txnStatus === 'TXN_FAILURE') {
          cleanup();
          setShowUpiBarCode(false);
          setshowUpiPopUp(false);
          setShowIntentStatusDialog(false);
          setshowLoader(false);
          setShowRetry(true);
          break;
        }
        
        await new Promise(resolve => setTimeout(resolve, 5000));
      }

      if (!isCheckingStatusRef.current || (intentPollingSession !== null && intentPollingSession !== intentPollingSessionRef.current)) {
        cleanup();
        return;
      }

      if (retries >= maxRetries) {
        cleanup();
        setShowUpiBarCode(false);
        setshowUpiPopUp(false);
        setShowIntentStatusDialog(false);
        setshowLoader(false);
        setShowRetry(true);
      }
    } catch (error) {
      console.log("Error in checkTransactionStatus:", error);
    }
  };



const submitFormWithPayId = (payId, var1, var2) => {
  const form = document.getElementById('submitUpi');
  const payIdInput = form.querySelector('input[name="payId"]');
  const var1Input = form.querySelector('input[name="var1"]');
  const var2Input = form.querySelector('input[name="var2"]');
  
  payIdInput.value = payId;
  var1Input.value = var1;
  var2Input.value = var2;
  
  form.submit();
};

  const renderIosPspIcon = (appName, iconSize = null) => {
    if (appName === 'PhonePe') {
      const sizeStyle = iconSize ? { width: iconSize, height: iconSize } : {};
      return (
        <span className='ios-upi-phonepe-custom-icon' aria-hidden='true' style={sizeStyle}>
          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <circle cx="100" cy="100" r="100" fill="#5E2CA5" />
            <text
              x="50%"
              y="55%"
              dominantBaseline="middle"
              textAnchor="middle"
              fontSize="110"
              fontFamily="Noto Sans Devanagari, Arial, sans-serif"
              fill="white"
            >
              {String.fromCodePoint(0x092a, 0x0947)}
            </text>
          </svg>
        </span>
      );
    }
    if (iconSize) {
      return (
        <ImageComponents
          className={appName}
          name={appName}
          style={{ width: iconSize, height: iconSize, objectFit: 'contain', display: 'block' }}
        />
      );
    }
    return <ImageComponents className={appName} name={appName} />;
  };

  const shouldShowIosUpiIntentApps = isIosDevice && isEligibleForIosPSPIntent;
  const shouldShowDefaultUpiIntent = showUpiIntent && !shouldShowIosUpiIntentApps;

  return (
    <>
       {showLoader && !showIntentStatusDialog && <Loader show={true} textToShow="Please wait while your transaction is being processed"/>}
      <form
        className="form-field"
        action={actionUrl}
        method="post"
        id="submitUpi"
        autoComplete="off"
      >
        <input type="hidden" name="payId" id="payId" />
        <input type="hidden" name="var1" id="var1" value={var1} />
        <input type="hidden" name="var2" id="var2" value={var2} />
      </form>

      <div className='card-details bg-white px-7 py-5'>
        <div className='card-detail-form'>
          {shouldShowDefaultUpiIntent && (
            <>
              <div className='upi-payment-type'>
                <h3 className='relative sm:mt-2 sm:mb-1'>Pay using Apps<span className='  absolute right-5'>
                     </span>
                </h3>
                <div className='sm:py-1 pe-3 ps-0 sm:mt-3'>
                  <Button className='pay-now-btn' onClick={() => handleIntentPayNow()}>CHOOSE AN APP</Button>
                </div>
              </div>
            </>
          )}
          {shouldShowIosUpiIntentApps && (
            <>
              <div className='upi-payment-type'>
                <h3 className='relative sm:mt-2 sm:mb-1'>
                  Pay using UPI Apps
                  <span className='absolute right-5'></span>
                </h3>
                <p>Select your preferred UPI app to continue payment.</p>
                <ul className='ios-upi-app-grid'>
                  {IOS_UPI_APPS.map((app) => (
                    <li key={app.name} className='ios-upi-app-item'>
                      <div
                        onClick={() => handleIntentPayNow(app.appPackage, app.name)}
                        className='ios-upi-app-card'
                      >
                        {renderIosPspIcon(app.name)} {app.name}
                      </div>
                    </li>
                  ))}
                </ul>
                <div className='ios-upi-app-separator'></div>
              </div>
            </>
          )}
          <div class="hidden md:block">
            {(showUpiQR || isEligibleForUpiCollect) && (
              <div className='card-info'>
                <h5>
                  Pay using UPI
                </h5>
                <div className='scan-pay-box'>
                  <ul>
                    {showUpiQR && (
                      <>
                        <li>
                          <h3>Scan and Pay</h3>
                          <div className='barcode-icon'>
                            <ImageComponents name={"barcode"} />
                            <Button className='genrate-qrcode' onClick={() => handleQRPayNow()} >View</Button>
                          </div>
                        </li>
                      </>

                    )}
                    {isEligibleForUpiCollect && (
                      <li>
                        <h3>Enter UPI ID</h3>
                        <form className='mt-3'>
                          <TextField
                            id="vpa-input"
                            label="mobilenumber@upi"
                            fullWidth
                            value={vpa}
                            error={!!validVPAerror}
                            helperText={validVPAerror}
                            onChange={handleVpaChange}
                            onClick={handleVpaClick}
                          />
                          <Button className="verify-pay-btn" onClick={() => handlePayNow()}>
                            Verify & Pay
                          </Button>
                        </form>
                        <div id="stepper">
                          <ul class="steps">
                            <li class="">
                              <span>Enter your registered VPA</span>
                            </li>
                            <li class="steps">
                              <span>Receive payment request on payment app</span>
                            </li>
                            <li class="non-active">
                              <span>Authorize payment request</span>
                            </li>
                          </ul>
                        </div>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            )}
          </div>
          <div class="block md:hidden">
            {(showUpiQR || isEligibleForUpiCollect) && (
              <div className='card-info'>
                <h5>
                  Pay using UPI
                </h5>
                <div className='scan-pay-box'>
                  <ul>
                    {isEligibleForUpiCollect && (
                      <li>
                        <h3>Enter UPI ID</h3>
                        <form className='mt-3'>
                          <TextField
                            id="vpa-input"
                            label="mobilenumber@upi"
                            fullWidth
                            value={vpa}
                            error={!!validVPAerror}
                            helperText={validVPAerror}
                            onChange={handleVpaChange}
                            onClick={handleVpaClick}
                          />
                          <Button className="verify-pay-btn" onClick={() => handlePayNow()}>
                            Verify & Pay
                          </Button>
                        </form>
                        <div id="stepper">
                          <ul class="steps">
                            <li class="">
                              <span>Enter your registered VPA</span>
                            </li>
                            <li class="steps">
                              <span>Receive payment request on payment app</span>
                            </li>
                            <li class="non-active">
                              <span>Authorize payment request</span>
                            </li>
                          </ul>
                        </div>
                      </li>
                    )}
                    {showUpiQR && (
                      <>
                        <li>
                          <h3>Scan and Pay</h3>
                          <div className='barcode-icon'>
                            <ImageComponents name={"barcode"} />
                            <Button className='genrate-qrcode' onClick={() => handleQRPayNow()} >View</Button>
                          </div>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      
     
      <Dialog  
        open={showUpiPopUp} 
        disableEscapeKeyDown 
        disablePortal
        disableAutoFocus
        BackdropProps={{
          onClick: (e) => e.stopPropagation()
        }}
      >
        <UpiPaymentProcess QrCodeData = {QrCodeData} handleCloseDialog={handleCloseDialog}  vpa={vpa} />
      </Dialog>
      
      <Dialog 
        open={showUpiBarCode} 
        disableEscapeKeyDown 
        disablePortal
        disableAutoFocus
        BackdropProps={{
          onClick: (e) => e.stopPropagation()
        }}
        className='upi-dialog'
      >
        <UpiQR  QrCodeData={QrCodeData} handleCloseDialog={handleCloseDialog} txAmount = {txAmount} mode = {mode}/>
      </Dialog>
      
      <IntentPaymentStatusDialog
        open={showIntentStatusDialog}
        title="Complete your payment. We'll confirm it automatically once it's successfull."
        onCancelPayment={cancelIntentPayment}
      />

      <Dialog 
        open={showRetry} 
        disableEscapeKeyDown 
        disablePortal
        disableAutoFocus
        BackdropProps={{
          onClick: (e) => e.stopPropagation()
        }}
      >
        <PaymentFailedPopup  handleCloseDialog={handleCloseDialog} retryPayment={retryPayment}  />
       </Dialog>

      <Dialog
        open={showAppNotInstalled}
        disableEscapeKeyDown
        disablePortal
        disableAutoFocus
        BackdropProps={{ onClick: (e) => e.stopPropagation() }}
        TransitionProps={{ onExited: handleAppNotInstalledExited }}
        PaperProps={{
          style: {
            borderRadius: '16px',
            maxWidth: '320px',
            width: '90vw',
            overflow: 'hidden',
            boxShadow: '0px 8px 32px 0px rgba(52, 105, 203, 0.22)',
          }
        }}
      >
        <div style={{ background: '#fff', padding: '24px 20px 20px', textAlign: 'center' }}>

          <div style={{
            width: '60px', height: '60px', borderRadius: '16px',
            background: '#F4F6F8',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 12px', overflow: 'hidden',
            border: '1px solid #E8ECF0',
          }}>
            {renderIosPspIcon(notInstalledAppName, '42px')}
          </div>
          <h2 style={{
            margin: '0 0 4px', color: '#253858',
            fontSize: '1rem', fontWeight: 700,
            fontFamily: 'Roboto, "Segoe UI", sans-serif',
            letterSpacing: '-0.01em', lineHeight: 1.3
          }}>
            App Not Found
          </h2>
          <p style={{
            margin: '16px 16px', color: '#5E6C84',
            fontSize: '0.79rem', fontFamily: 'Roboto, "Segoe UI", sans-serif',
            lineHeight: 1.55
          }}>
            <strong style={{ color: '#253858' }}>{notInstalledAppName}</strong> is not installed on this device.
            Please select a different UPI app to continue.
          </p>

          <Button
            onClick={handleCloseAppNotInstalled}
            style={{
              background: '#3965FB',
              color: '#fff', borderRadius: '8px',
              padding: '10px 0', width: '100%',
              fontWeight: 600, textTransform: 'none',
              fontSize: '0.9rem', letterSpacing: '0.01em',
              fontFamily: 'Roboto, "Segoe UI", sans-serif'
            }}
          >
            Try Another App
          </Button>
        </div>
      </Dialog>
      
      
 {showCheck && isMotorProduct && <div className="payment-error-box"  style={{
    margin: '-38px 0 0',
    fontSize: 'small',
  }}>
  Transaction confirmation status is pending. If the amount has already been deducted from your account, we recommend you wait for 15-20 minutes before making another payment attempt. 
</div>}
{!showCheck && isMotorProduct && <div className="payment-error-box"  style={{
    margin: '-38px 0 0',
    fontSize: 'small',
  }}>
  Transaction confirmation for UPI takes longer than other payment modes. Given the delay, we recommend you wait for some time before making another payment attempt using UPI.
</div>}
    </>
  )
}

export default UpiDetails;

